export const LEAD_RESIZE_MESSAGE_TYPE = 'pooldial:lead:resize';

export const isLeadEmbedMode = (search: string): boolean =>
  new URLSearchParams(search).get('embed') === '1';

export const createLeadResizeMessage = (slug: string, height: number) => ({
  source: 'pooldial-lead',
  type: LEAD_RESIZE_MESSAGE_TYPE,
  slug,
  height: Math.ceil(height),
});
